<template>
    <c-input-element :label="label" :helptext="helptext" :class="{ 'c-form-element--horizontal' : horizontal }" :name="$attrs.name">
        <textarea v-bind="$attrs" v-model="value"></textarea>
    </c-input-element>
</template>

<script>
import Input from '@mixins/Input';

export default {
    name: 'form-textarea-input',
    inheritAttrs: false,
    mixins: [Input],
    props: {
        
    }
}
</script>